import Transport from './transport/IframeTransport';
import jsonRpc from './protocol/jsonRpc';
import Dispatcher from './Dispatcher';
import * as connector from './connector';

import resolver from './resolver';

const dispatcher = new Dispatcher(jsonRpc);

export const resolve = resolver(dispatcher);
export const connect = transport => connector.connect(transport, dispatcher);
export const disconnect = transport => connector.disconnect(transport, dispatcher);

export default {
  connect,
  disconnect,
  dispatcher,

  Transport,
};



// WEBPACK FOOTER //
// ./src/WebBridge/index.js